// @flow strict

import * as React from 'react';
import styles from './styles.scss';

export default (props: { startTime: string, endTime?: string, location: string }) => {
  let date;
  const start = new Date(props.startTime);

  if (props.endTime) {
    const end = new Date(props.endTime);
    date = `${start.toDateString()} - ${end.toDateString()}`;
  } else {
    date = start.toDateString();
  }

  return (
    <span className={styles.meta}>
      {date}
      <br />
      {props.location}
    </span>
  );
};
